"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityReference = void 0;
const typebox_1 = require("@sinclair/typebox");
const entity_type_1 = require("../common/entity-type");
exports.EntityReference = typebox_1.Type.Object({
    entityType: entity_type_1.EntityType,
    id: typebox_1.Type.String(),
});
//# sourceMappingURL=entity-reference.js.map